import { HTMLProjectionNode } from "motion-dom";
import { MeasureLayout } from "./layout/MeasureLayout";
export const layout = {
    layout: {
        ProjectionNode: HTMLProjectionNode,
        MeasureLayout,
    },
};
//# sourceMappingURL=layout.js.map